<template>
    <div>
        <headers :title='titles'></headers>
        <div class="content">
            <p>学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;科：
                <span v-if='sid==2'>数学</span>
                <span v-if='sid==5'>语文</span>
                <span v-if='sid==9'>英语</span>
                <span v-if='sid == 11 || sid == 1114'>书法</span>
                <span v-if='sid==12'>编程</span>
                <span v-if='sid==13'>模型</span>
                <span v-if='sid==24'>围棋</span>
            </p>
            <p>布置时间：{{msg._betime}} {{time}}</p>
            <p v-if='sid == 9'>截止时间：{{msg.end_date.slice(0,16)}}</p>
            <p v-if='sid == 2 || sid == 5'>截止时间：{{msg.end_time?msg.end_time.slice(0,16):'--'}}</p>
            <div class="task_list">
                <span class="task_title">作业内容：</span>
                <hr>
                <p class="task_content">
                    <!-- 家长您好，今天<span>（2018-05-03）</span>语文的课前预习作业已发到同步课堂手机APP，作业截
          至请您及时督促孩子登陆手机客户端完成作业。【<span>张小涛教师</span>】 -->
                    {{msg.content}}
                </p>
            </div>
            <div class="bth">
                <!-- <span class="bth_t1" @click="sendMsg">{{msg.begin_time.length?'定时短信通知家长':'短信通知家长'}}</span> -->
                <span class="bth_t1"
                      @click="shart"
                      v-if="msg.begin_time.length==0">分享作业到家长群</span>
                <span class="bth_t2"
                      @click='next'>跳过</span>
            </div>
        </div>
        <!-- <div class="img" v-if="hdUrl!=''">
      <img src="./img/teahd02.png" @click="tohd()">
    </div> -->

        <!-- 期中活动弹框 -->

        <!-- <midTipsModel v-if="midShowTipsModel" @closeTipsModel="midShowTipsModel=false;"/> -->
        <!-- <fourTipsModel v-if="fourShowTipsModel&&user_id!=545825" @closeTipsModel="fourShowTipsModel=false;"/> -->
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue';
// import midTipsModel from 'SRC/components/activity/termBeginsLucky/tea-mid/tipsModel.vue';  // 期中活动弹框
//import fourTipsModel from 'SRC/components/activity/termBeginsLucky/four_term/tipsModel.vue';  // 期末活动弹框

export default {
    data () {
        return {
            showTipsModel: true,  // 期中活动弹框
            titles: '作业单',
            sid: this.$route.query.sid,
            subject: this.$route.query.subject,
            message_id: this.$route.query.message_id,
            time: null,
            tbkt_Token: localStorage.getItem("Tbkt-Token"),
            city_id: localStorage.getItem('city_id'),
            midShowTipsModel: false,
            fourShowTipsModel: false,
            is_active: Number(this.$route.query.is_active) || 0, //是否来自寒假活动
            user_id: null,
            // hdUrl:'',
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            short_url: '',//分享的短链
            is_personal: this.$route.query.is_personal,
            qualityStation: this.$route.query.qualityStation
        }
    },
    methods: {
        /**获取分享短链地址 */
        getShortUrl () {
            let unit_ids = this.msg.unit_class_ids, url = "";
            if (this.qualityStation == 1) {
                url = `${WAP_URL}/common/login/?user_type=1&is_share=1&unit_ids=${unit_ids}`
            } else {
                url = `${WAP_URL}/qr/special?is_sum=1&is_share=2&sid=${this.subject}&unit_ids=${unit_ids}`
            }
            this.$http.post(API_URL_SORT_API + '/create_sort/', {
                url: url,
                sort_type: 1
            }).then((res) => {
                if (res.data.response === 'ok') {
                    this.short_url = res.data.data.short_url
                }
            })
        },
        shart () {
            let url = VUE_URL_HD + `/#/share/send_task?message_id=${this.message_id}&sid=${this.sid}&tbkt_token=${this.tbkt_Token}`
            let title = `同步课堂`;
            if (this.city_id == "411600") {
                title = "随堂练";
            }
            if (this.inApp) {
                //个性化学习分享按钮
                if (this.is_personal == 1) {

                    let subject = ''
                    let type = ''

                    //数学科目
                    if (this.subject == 21) {
                        subject = '数学'
                        if (this.$route.query.type == 1) {
                            type = "同步习题"
                        }
                        //同步习题
                        if (this.$route.query.type == 2) {
                            type = "每周一测"
                        }
                        //同步习题
                        if (this.$route.query.type == 3) {
                            type = "单元复习"
                        }
                    }
                    //语文科目 
                    if (this.subject == 51) {
                        subject = '语文'
                        //单元复习
                        if (this.$route.query.type == 3) {
                            type = "单元复习"
                        }
                        //同步习题
                        if (this.$route.query.type == 2) {
                            type = "同步习题"
                        }
                    }
                    title = this.msg.end_time.slice(5, 7) + '月' + this.msg.end_time.slice(8, 10) + '日' + subject + '学习内容'
                    let content = '截止时间：' + this.msg.end_time.slice(0, 16) + '，点击查看详情'
                    this.appFunction("ys_share", `${title},${content},${this.short_url}`);
                }
                //素质驿站APP分享
                else if (this.qualityStation == 1) {
                    let subject = ''
                    if (this.sid == 11) {
                        subject = '爱尚书法'
                    }
                    if (this.sid == 12) {
                        subject = '爱尚编程'
                    }
                    if (this.sid == 13) {
                        subject = '爱尚模型'
                    }
                    title = this.msg.end_time.slice(5, 7) + '月' + this.msg.end_time.slice(8, 10) + '日' + subject + '学习内容'
                    let content = '截止时间：' + this.msg.end_time.slice(0, 16) + '，点击查看详情'
                    this.appFunction("ys_share", `${title},${content},${this.short_url}`);
                }
                else {
                    this.appFunction("ys_share", `${title},${this.msg.content},${url},${this.sid},0,0,0,教师发布作业之后分享`)
                }

            } else {
                //h5分享
                if (this.is_personal == 1) {
                    let coptText = this.msg.content;
                    this.copyText(coptText);
                    this.copyVisible = true;
                    layer.alert('将链接分享到对应的班级群，点击链接即可个性化学习。', 'tea', function (index) {
                        layer.close(index)
                    }, '分享链接复制成功')
                }
                else if (this.qualityStation == 1) {
                    let coptText = `家长您好，今天的学习内容已发布，点击链接即可查看，链接：${this.short_url} `;
                    this.copyText(coptText);
                    this.copyVisible = true;
                    layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                        layer.close(index)
                    }, '分享链接复制成功')
                }
                else {
                    let coptText = `${this.msg.content},链接：${url}`;
                    this.copyText(coptText);
                    this.copyVisible = true;
                    layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                        layer.close(index)
                    }, '分享链接复制成功')
                }
            }
            // try {
            //   appobject.Interactive(`ys_share,${title},${this.msg.content},${url}`)
            // } catch (e) {
            //   //console.log(`ys_share,${title},${this.msg.content},${url}`)
            // }
            //console.log(`ys_share,${title},${this.msg.content},${url}`)

        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        next () {
            if (this.is_winter) {
                this.$router.replace('/activity/2020winter/tea/index'); //跳转到活动首页
            } else {
                this.$router.replace('/subjectChoose/0');
            }
        },
        // tohd(){
        //   if(this.hdUrl!=''){
        //     this.$router.push(this.hdUrl+'&teahd=1');
        //   }
        // }
        sendMsg () {
            this.$router.push('/release/sendsms?message_id=' + this.message_id);
        }
    },
    created () {
        let time = new Date();
        let hTime = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
        let mTime = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
        this.time = hTime + ':' + mTime;
        let info = JSON.parse(localStorage.getItem('info'));
        this.user_id = info.id;
        // 活动弹框 自动消失


        let fourEndTime = new Date('2020/11/21 23:59:59').valueOf();
        let today = new Date().valueOf();


        // this.fourShowTipsModel = today<fourEndTime?true:false;
        let subject = this.subject;
        // //console.log(subject)
        if (subject != 92) {
            this.fourShowTipsModel = today < fourEndTime ? true : false;
        }
        this.getShortUrl()
    },
    components: {
        headers,
        // midTipsModel,
        //   fourTipsModel
    },
    mounted () {
        // //console.log(this.msg)
    },
    computed: {
        msg () {
            console.log(this.$store.state.msg)
            return this.$store.state.msg;
        },
        isEnd () {  // 期末活动是否结束

            // let endDay = new Date('2019-12-31 23:59:59').valueOf();
            // // let endDay = new Date('2019-11-06 10:30:00').valueOf();
            // let today = new Date().valueOf();
            // if(today > endDay) { // 结束
            //     return true;
            // } else {
            //     return false;
            // }
        }
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.content {
    p {
        color: #333333;
        padding: 0 30px / $ppr 30px / $ppr;
        background: #fff;
        line-height: normal;
    }
    p:first-child {
        padding-top: 30px / $ppr;
    }
    .task_list {
        margin-top: 30px / $ppr;
        background: #fff;
        height: 100%;
        padding-bottom: 32px / $ppr;
        .task_title {
            color: #333333;
            display: inline-block;
            padding: 0 30px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            height: 95px / $ppr;
        }
        hr {
            margin-top: 0;
            border: 1px / $ppr solid #e8e8e8;
        }
        .task_content {
            border-radius: 0.25rem;
            padding: 20px / $ppr;
            margin: 32px / $ppr 32px / $ppr 0;
            color: #999999;
            background: #f7f7f7;
            //font-weight: 100;
        }
    }
}

.bth {
    padding: 20px / $ppr 0;
    span {
        width: 80%;
        margin: 30px / $ppr auto;
        display: block;
        text-align: center;
        padding: 20px / $ppr 0;
        border-radius: 50px / $ppr;
    }
    .bth_t1 {
        background: #5e89ef;
        color: #fff;
    }
    .bth_t2 {
        border: 1px / $ppr solid #5e89ef;
        color: #5e89ef;
    }
}
.img {
    width: 100%;
    // height:360px/$ppr;
    img {
        // position:fixed;
        // bottom:0;
        // left:0;
        // right:0;
        width: 100%;
        display: block;
        // height:360px/$ppr;
        // z-index:8;
    }
}
</style>
